import { useState, useEffect } from 'react';

export default function ArabicLoader({ message }) {
  const MESSAGES = message
    ? [message]
    : ['Reading the verse…', 'Finding the roots…', 'Preparing the tools…'];

  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (MESSAGES.length === 1) return;
    const t = setInterval(() => setIdx(i => (i + 1) % MESSAGES.length), 2500);
    return () => clearInterval(t);
  }, []);

  return (
    <div style={{ textAlign: 'center', padding: '2rem 0' }}>
      <div style={{
        fontSize: '1.25rem',
        color: 'var(--gold)',
        marginBottom: '0.75rem',
        animation: 'arabicPulse 2s ease-in-out infinite',
        lineHeight: 1,
      }}>
        ✦
      </div>
      <div style={{
        fontFamily: "'Josefin Sans', sans-serif",
        fontSize: '0.58rem',
        letterSpacing: '0.15em',
        textTransform: 'uppercase',
        color: 'var(--text3)',
      }}>
        {MESSAGES[idx]}
      </div>
    </div>
  );
}
